
import $obj from './el-table-highlight'
const directiveName = 'el-table-highlight'

const install = function(Vue) {
  Vue.directive(directiveName, $obj)
}
 
if (window.Vue) {
  window[directiveName] = $obj
  Vue.use(install); // eslint-disable-line
}
 
$obj.install = install
export default $obj
